<template>
  <section class="page-section page---welcome ">
    <div class="container-fluid">
      <div id="veiling" class="row align-items-end justify-content-between">
        <Item :item="item" :controls="controls" v-if="item.id"></Item>
        <Clock id="clock" class="clock-display-none" :item="item"></Clock>
        <Price :item="item" :bidder="bidder" v-if="item.id"></Price>
        <Welcome v-if="!item.id && !finished"></Welcome>
        <End v-if="finished" :summary="summary"></End>
      </div>
      <div id="scoreBoard" class="score-board" style="display: none;">
        <ScoreBoard :summary="summary"></ScoreBoard>
      </div>
    </div>
  </section>
</template>

<style scoped>
  .clock-display-none{
    display: none;
  }
</style>

<script>
import Item from "./clock/Item";
import Clock from "./clock/Clock";
import Price from "./clock/Price";
import Welcome from "./clock/Welcome";
import End from "./clock/End";
import ScoreBoard from "./clock/ScoreBoard";

export default {
  components: {
    Welcome,
    Price,
    Item,
    Clock,
    End,
    ScoreBoard,
  },
  data() {
    return {
      item: {},
      bidder: {},
      finished: false,
      controls: false,
      summary: {},
      scoreBoard: false,
    };
  },
  mounted() {
    this.getActiveItem();
    this.listen();
  },
  methods: {
    getActiveItem() {

      let csrfToken = document.head.querySelector('meta[name="csrf-token"]').content;

      axios({
        method: 'GET',
          url: '/api/auction/' + this.getAuctionIdFromUrl() + '/item/active',
        data: {'X-CSRF-TOKEN': csrfToken},
      })
          .then(response => {
            if (
                response.data.status &&
                response.data.status == 'success' &&
                response.data.data) {
              this.item = response.data.data;
              this.finished = false;
              document.getElementById("clock").classList.remove('clock-display-none');
            }
          });
    },
    getSummary() {

      let csrfToken = document.head.querySelector('meta[name="csrf-token"]').content;

      axios({
        method: 'GET',
        url: '/api/auction/' + this.getAuctionIdFromUrl() + '/summary',
        data: {'X-CSRF-TOKEN': csrfToken},
      })
          .then(response => {
            if (
                response.data.status &&
                response.data.status == 'success' &&
                response.data.data) {
              this.summary = response.data.data;
            }
          });
    },
    listen() {
      const test = Echo.channel('auction-channel-' + this.getAuctionIdFromUrl())
          .listen('.item.auction.active', (e) => {
            document.getElementById("clock").style.display = 'block';
            this.item = e.auctionItem;
            this.finished = false;
          })
          .listen('.auction.finished', (e) => {
            document.getElementById("clock").style.display = 'none';
            this.finished = true;
            this.getSummary();
            this.item = {};
          })
          .listen('.item.auction.restart', (e) => {
            this.item.purchased_by = [];
          })

        const event = Echo.private('auction-channel-' + this.getAuctionIdFromUrl())
          .listenForWhisper('scoreBoard', (e) => {
            this.getSummary();

            if(this.scoreBoard == false){
              document.getElementById('veiling').style.display = 'none';
              document.getElementById('scoreBoard').style.display = 'block';
              this.scoreBoard = true;
            }
            else{
              document.getElementById('veiling').style.display = 'flex';
              document.getElementById('scoreBoard').style.display = 'none';
              this.scoreBoard = false;
            }
          })
          .listenForWhisper('startScreen', () => {
            window.location.reload();
          })
    },
    getAuctionIdFromUrl(){
        return parseInt(window.location.pathname.split('/')[2]);
    }
  }
}
</script>
